var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlayBlau(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#027eb5;}.cls-2,.cls-3{fill:none;}.cls-3{stroke:#027eb5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4",
    "data-name": "Gruppe 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    className: "cls-1",
    d: "M21.21,14.61A1,1,0,0,1,21.66,16a1,1,0,0,1-.45.44l-8.76,4.39a1,1,0,0,1-1.45-.9V11.12a1,1,0,0,1,1-1,1,1,0,0,1,.45.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15.5,
    cy: 15.5,
    r: 15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayBlau);
export default __webpack_public_path__ + "static/media/icon_play_blau.a4e650639380663ee50f6c096d1eafe0.svg";
export { ForwardRef as ReactComponent };